import { useCallback } from 'react';

import { Spinner } from '@change/ds-core-ui';

import { withI18nPlaceholders } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';

import I18N_PLACEHOLDERS_SAP from 'config/i18n/placeholders/growth/sap.yml';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { MediaStep } from './Media';

async function LoadMediaStep(): Promise<typeof MediaStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-media" */ './Media')).MediaStep;
}

export const MediaLoader = withI18nPlaceholders(I18N_PLACEHOLDERS_SAP, () => {
	const loadComponent = useCallback(LoadMediaStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Spinner />
				</Box>
			}
		/>
	);
});

export const preloadMediaStep = LoadMediaStep;
